<div id="collaborative-initiatives" class="watermark py-4">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">

        <!-- Elegant Heading Banner & Quote -->
        <div class="collaborative-header text-center">
          <div class="header-banner mb-4">
            <h2 class="header-title m-0">Collaborative Initiatives of IQAC</h2>
          </div>
          <h5 class="quote-text mb-2">“Empowering Quality, Together, Collaborate to Elevate Standards.”</h5>
          <h6 class="sub-header-title">Memorandum of Understanding (MoU)</h6>
          <hr class="divider mx-auto" style="width: 80px; height: 3px; background: var(--secondary); border: none; opacity: 1; margin-top: 1rem; margin-bottom: 0;">
        </div>

        <!-- Premium Styled Table Container -->
        <div class="table-responsive-inner mt-4">
          <table class="inner-table text-center">
            <thead>
              <tr>
                <th scope="col" class="text-center" style="width: 80px;">S.No</th>
                <th scope="col" class="text-center" style="width: 180px;">Date</th>
                <th scope="col" class="text-center" style="width: 150px;">Session</th>
                <th scope="col" class="text-start">Name of Party/Institution/Industry, NGO etc.</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center fw-semibold">1</td>
                <td class="text-center">18 May, 2026</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">Samarghosh Infotech</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">2</td>
                <td class="text-center">26 Feb, 2026</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">Manohar Memorial college, Fatehabad</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">3</td>
                <td class="text-center">23 Feb, 2026</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">Govt. College for Girls, Rania</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">4</td>
                <td class="text-center">23 Feb, 2026</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">Govt. College, Goriwala</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">5</td>
                <td class="text-center">06 Nov, 2025</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">Department Of Physical Education, Guru Kashi University, Talwandi Sabo</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">6</td>
                <td class="text-center">06 Nov, 2025</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">Sarla Memorial Govt. Girls College, Safidon, Jind</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">7</td>
                <td class="text-center">15 Oct, 2025</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">HDFC Bank</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">8</td>
                <td class="text-center">09 Oct, 2025</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">Narang Hospital , Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">9</td>
                <td class="text-center">08 Oct, 2025</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">Life Insurance Corporation of India, Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">10</td>
                <td class="text-center">25 Sep, 2025</td>
                <td class="text-center">2025-2026</td>
                <td class="text-start">SIRCL Tech. Pvt. Ltd</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">11</td>
                <td class="text-center">21 Nov, 2024</td>
                <td class="text-center">2024-2025</td>
                <td class="text-start">Great Future Technology Pvt . Ltd</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">12</td>
                <td class="text-center">09 Oct, 2024</td>
                <td class="text-center">2024-2025</td>
                <td class="text-start">GCW, Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">13</td>
                <td class="text-center">26 April, 2024</td>
                <td class="text-center">2023-2024</td>
                <td class="text-start">Institution of Charted Accountants of India (ICAI), Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">14</td>
                <td class="text-center">20 April, 2024</td>
                <td class="text-center">2023-2024</td>
                <td class="text-start">Satguru Industries, Sirsa Haryana</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">15</td>
                <td class="text-center">18 April, 2024</td>
                <td class="text-center">2023-2024</td>
                <td class="text-start">Yog Mitra Charitable Trust, Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">16</td>
                <td class="text-center">18 April, 2024</td>
                <td class="text-center">2023-2024</td>
                <td class="text-start">ICICI Bank, Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">17</td>
                <td class="text-center">16 April, 2024</td>
                <td class="text-center">2023-2024</td>
                <td class="text-start">Post Office, Sirsa, Haryana</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">18</td>
                <td class="text-center">15 April, 2024</td>
                <td class="text-center">2023-2024</td>
                <td class="text-start">Softech Infoways, Suvidha Marg, Aggarsain Colony, Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">19</td>
                <td class="text-center">08 April, 2024</td>
                <td class="text-center">2023-2024</td>
                <td class="text-start">Red Cross Society, Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">20</td>
                <td class="text-center">08 Feb, 2024</td>
                <td class="text-center">2023-2024</td>
                <td class="text-start">Kuber Agro Industry, Village- Moriwala, Distt. Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">21</td>
                <td class="text-center">09 May, 2023</td>
                <td class="text-center">2022-2023</td>
                <td class="text-start">Chandan Mal Karnani National Post Graduate College, Sirsa</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">22</td>
                <td class="text-center">14 Feb, 2023</td>
                <td class="text-center">2022-2023</td>
                <td class="text-start">Chaudhary Mani Ram Godara Govt College for Women, Bodia khera, Fatehabad</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">23</td>
                <td class="text-center">28 Jan, 2023</td>
                <td class="text-center">2022-2023</td>
                <td class="text-start">Chaudhary Mani Ram Jhorar Govt College, Mithi Surera, Ellenabad</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">24</td>
                <td class="text-center">17 Jun, 2022</td>
                <td class="text-center">2022-2023</td>
                <td class="text-start">Sanatan Dharama College, Ambala Cantt.</td>
              </tr>
              <tr>
                <td class="text-center fw-semibold">25</td>
                <td class="text-center">28 May, 2022</td>
                <td class="text-center">2021-2022</td>
                <td class="text-start">Government National College, Sirsa</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</div>

